
























import { Vue, Component } from "vue-property-decorator";
import { Getter } from "vuex-class";
import getUrlParam from '@/common/utils/getUrlParam';
import { replaceString } from '@/common/utils/dealWithString';
import getActivityDeadline from '@/common/utils/getActivityDeadline';
@Component
export default class GachaCountDown extends Vue {
  @Getter("title") getterTitle!: string;
  @Getter("startTime") startTime: any;
  @Getter("deadline") deadline!: number;
  @Getter("titleSection") titleSection!: object
  type: string = getUrlParam("type") as string;
  get title(): string {
    return replaceString(this.getterTitle);
  }
  get activityStatus():string {
    const activityDeadline: number = this.deadline;
    const activityStartTime: number = this.startTime;
    const nowTimestamp: number = new Date().valueOf();
    if(activityStartTime > nowTimestamp){
      return "noStart";
    }else{
      if(nowTimestamp<activityDeadline){
        return "startIng";
      }else{
        return "endIng";
      }
    }
  }
  // 剩余天数
  get deadlineDay(): number {
    if(this.activityStatus === "noStart"){
      return getActivityDeadline(this.startTime).deadlineDay;
    }else{
      return getActivityDeadline(this.deadline).deadlineDay;
    }
  }
  // 剩余小时
  get deadlineHour(): string | number {
    if(this.activityStatus === "noStart"){
      return getActivityDeadline(this.startTime).deadlineHour;
    }else{
      return getActivityDeadline(this.deadline).deadlineHour;
    }
  }
  // 剩余分钟
  get deadlineMinute(): string | number {
    if(this.activityStatus === "noStart"){
      return getActivityDeadline(this.startTime).deadlineMinute;
    }else{
      return getActivityDeadline(this.deadline).deadlineMinute;
    }
  }

}
